import { useTranslation } from "react-i18next";
import { Box, Checkbox, Flex, Grid, Text } from "@mantine/core";
import { CampaignInquiryQueryDataType } from "src/hooks/campaignInquiries";

import { FormItem } from "../../../FormItem";

export interface CampaignInquiryPricingProps {
    campaignInquiry: CampaignInquiryQueryDataType;
}

export const CampaignInquiryPricing = ({ campaignInquiry }: CampaignInquiryPricingProps) => {
    const { t } = useTranslation(["common"]);

    return (
        <Grid>
            <Grid.Col xs={12} sm={6} md={6}>
                <Flex>
                    <Box w="auto" mr="sm">
                        <Checkbox
                            label={t("campaign_pricing_isfree")}
                            checked={campaignInquiry?.pricing?.isFree}
                            disabled
                            onChange={() => { }}
                        />
                    </Box>
                    <Box style={{ flex: 1 }}>
                        <FormItem label={t("campaign_pricing_discount")}>
                            {typeof campaignInquiry?.pricing?.discountPercent === "number" ? (
                                `${campaignInquiry.pricing.discountPercent}%`
                            ) : (
                                <Text color="dimmed">-</Text>
                            )}
                        </FormItem>
                    </Box>
                </Flex>
            </Grid.Col>
            {/* <Grid.Col xs={12} sm={6} md={6}>
                <Flex align="flex-start">
                    <Box style={{ flex: 1 }}>
                        <DiscountCodesEditor
                            // {...campaignForm.getInputProps("pricing.discountCodes")}
                            label={t("campaign_pricing_discountcodes")}
                            description={t("campaign_pricing_discountcodes_count", { count: createCampaignInquiryForm.values?.pricing?.discountCodes?.length || 0 })}
                            value={createCampaignInquiryForm.values?.pricing?.discountCodes}
                            onChange={(discountCodes) =>
                                createCampaignInquiryForm.setFieldValue("pricing.discountCodes", discountCodes)}
                        />
                    </Box>
                    <Button
                        onClick={() =>
                            ImportDiscountCodesModal.display({
                                currentDiscountCodes: createCampaignInquiryForm.values?.pricing?.discountCodes || [],
                                onSave: (discountCodes) =>
                                    createCampaignInquiryForm.setFieldValue("pricing.discountCodes", discountCodes),
                            })}
                    >
                        {t("add")}
                    </Button>
                </Flex>
            </Grid.Col> */}
        </Grid>
    );
};
